import { useMemo } from 'react';

import { getOrganizationId } from 'src/domain/user';
import { useSignedInUser } from './useSignedInUser';

export const useCurrentOrganizationId = () => {
    const user = useSignedInUser();

    return useMemo(() => {
        if (!user) {
            return undefined;
        }

        try {
            return getOrganizationId(user);
        } catch (error) {
            return undefined;
        }
    }, [user]);
};
